module.exports = __webpack_public_path__ + "media/images/icon/calendar-gray-6cc5006e57be4e99b8985861030302aa.svg";